var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{class:{
    'app-container': _vm.isAuthenticated,
    'app-container-public': !_vm.isAuthenticated
  },attrs:{"id":"app"}},[_c('notifications',{attrs:{"classes":"pa-3 app-notifications"}}),_c('app-modals-container',{ref:"modal",attrs:{"id":"modals-container"}}),(_vm.isAuthenticated)?_c('div',[_c('side-nav'),_c('app-nav'),_c('v-main',[_c('router-view')],1)],1):_c('div',[_c('public-nav'),_c('v-main',[_c('router-view')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }